import { List } from '@nexelem/deprecated-theme';
import { generateKebabCase } from '@nexelem/utils';
import { TreeListItem as TreeListRootItem } from './components/TreeListItem';
import { DISPLAY_FIELD, ToDoListViewProps } from './types';
import { TaskTree } from '@nexelem/graphne-api';
import { TreeViewSkeleton } from '../ProductionPlans/components/TasksDrawer/components/TreeViewSkeleton';

export type ToDoListTreeViewProps = ToDoListViewProps<TaskTree[]> & {
  displayField: DISPLAY_FIELD;
  hasMoreToLoad: boolean;
};

export const ToDoListTreeView = ({
  tasksList,
  onCheck,
  onMoreClick,
  isCheckAllFilterChecked,
  displayField,
  lastElementRef: ref,
  hasMoreToLoad,
}: ToDoListTreeViewProps) => (
  <div className="flex grow flex-col overflow-auto">
    <List disablePadding className="w-max min-w-full">
      {tasksList?.map((task, index) => (
        <TreeListRootItem
          depth={0}
          displayField={displayField}
          index={index}
          isCheckAllFilterChecked={isCheckAllFilterChecked}
          key={generateKebabCase('tree-list-item', task.id, index)}
          path=""
          ref={tasksList.length === index + 1 ? ref : undefined}
          task={task}
          onCheck={onCheck}
          onMoreClick={onMoreClick}
        />
      ))}
      {hasMoreToLoad && <TreeViewSkeleton rowsCount={3} />}
    </List>
  </div>
);
